export default __webpack_public_path__ + "static/media/2056.3cf6c797.png";